import axios from 'axios';

const baseUrl = window.config.API_URL;

// __________get users ___________

const getUser = async (page) => {
  const path = `/api/user/getAllUsers/${page || ''}`;
  const url = baseUrl + path;
  const response = await axios.get(url);
  return response?.data;
};

const getLastFiveUser = async (page) => {
  try {
    const path = `/api/user/getTopFiveUsers`;
    const url = baseUrl + path;
    const response = await axios.get(url);
    return response?.data;
  } catch (e) {
    console.log(e);
  }
};

const deleteAllUser = async (data) => {
  const path = `/api/user/deleteMultipleUser`;
  const url = baseUrl + path;
  const dataaa = [...data];
  const response = await axios.post(url, dataaa);
  return response.data;
};

// delete user;
const deleteUser = async (id) => {
  const { userid } = JSON.parse(localStorage.getItem('user'));

  if (userid === id) {
    localStorage.removeItem('user');
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }

  const path = `/api/user/deleteUser/${id}`;
  const url = baseUrl + path;
  const response = await axios.post(url);
  return response.data;
};

// view user;
const viewUser = async (id) => {
  console.log('iddd', id);
  const data = {
    userId: id,
  };
  const path = '/api/user/getUserDetail';
  const url = baseUrl + path;
  const response = await axios.post(url, data);
  return response?.data;
};

const editUser = async (dataa) => {
  const { userid } = JSON.parse(localStorage.getItem('user'));
  const data = {
    password: dataa?.password,
    email: dataa?.email,
    name: dataa?.name,
    userId: dataa?.userId || userid,
    status: dataa.status,
    roles: dataa.roles,
    user_status: dataa?.user_status,
  };
  const path = '/api/user/updateUser';
  const url = baseUrl + path;
  const response = await axios.post(url, data);
  return response.data;
};

// dashboard user data
const showingDashboardUser = async (id) => {
  const path = '/api/user/dashboardetail';
  const url = baseUrl + path;
  const response = await axios.get(url);
  return response.data;
};

const userLogList = async (page) => {
  const path = `/api/user/getAllUserLogin/${page || ''}`;
  const url = baseUrl + path;
  const response = await axios.get(url);
  console.log('logcon', response);
  return response.data;
};

// Profile / general
const updataProfileState = async (data) => {
  const { userid } = JSON.parse(localStorage.getItem('user'));

  console.log('hello', data);
  const path = '/api/user/updateProfile';
  const url = baseUrl + path;
  const datas = JSON.stringify(data);
  const useriId = JSON.stringify(userid);
  console.log('picsss', data.photoURL);
  const dataa = {
    userid,
    data,
  };

  const bodyFormData = new FormData();
  bodyFormData.append('picture', data?.photoURL);
  bodyFormData.append('profile', datas);
  bodyFormData.append('userId', useriId);

  const response = await axios.put(url, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer`,
    },
  });
};

const userServices = {
  getUser,
  deleteAllUser,
  deleteUser,
  viewUser,
  editUser,
  showingDashboardUser,
  getLastFiveUser,
  updataProfileState,
  userLogList,
};

export default userServices;
